/**
 * TheBeingCollective.co embed code
 * Adds statistics handler for the affiliated links
 * Should be added to every page, where affiliated link is present
 */

class SwPromoCodeEmbed {
  constructor() {
    const _this = this;

    this.url_regex = /^(?<domain>https?:\/\/(:?mealplanner|mealplanner\.devphase\.io|thebeingcollective\.co))\/register\?code=(?<code>[a-z0-9-_]+)(?:$|&)/gi;
    this.page_url = window.location.href;

    this.promocodes_sent = [];

    const promocode_page = this.getPromoCodeFromUrl(this.page_url);
    const domain_page = this.getDomainFromUrl(this.page_url);
    if ( promocode_page ) {
      this.eventSend('visit', promocode_page, domain_page);
    }

    const as = document.querySelectorAll('a[href*="/register?code"]');
    as.forEach((a) => {
      const href = a.getAttribute('href');
      const promocode_a = this.getPromoCodeFromUrl(href);
      const domain_a = this.getDomainFromUrl(href);
      if ( promocode_a ) {
        this.eventSend('view', promocode_a, domain_a);
      }
    });
  }

  getPromoCodeFromUrl ( url ) {
    this.url_regex.lastIndex = 0;
    const m = this.url_regex.exec(url);
    if ( m ) {
      return m.groups.code;
    }
    return null;
  }

  getDomainFromUrl ( url ) {
    this.url_regex.lastIndex = 0;
    const m = this.url_regex.exec(url);
    if ( m ) {
      return m.groups.domain;
    }
    return null;
  }

  eventSend( event_type, promocode, domain ) {
    domain = domain ? domain : 'https://thebeingcollective.co';
    if ( this.promocodes_sent.includes(promocode) ) {
      return;
    }
    this.promocodes_sent.push(promocode);

    console.log('TBC PC Evt:', event_type, promocode, domain );

    const url = domain + '/ajax/sw/promocode-event/' + event_type;

    const data = new FormData();
    data.append('promocode', promocode);
    data.append('referrer', document.referrer);
    fetch(url, {
      method: 'POST',
      cache: "no-cache",
      //cors: 'no-cors',
      body: data,
    })
      .then( resp => resp.json() )
      .then(resp => {
        if ( resp.status ) {
          console.log('TBC PC Resp OK:', resp.message );
        } else {
          console.log('TBC PC Resp Error:', resp.message );
        }
      });
  }
}

console.log('TBC PC Loaded' );

if ( document.readyState !== 'loading') {
  SwPromoCodeInit();
} else {
  document.addEventListener('DOMContentLoaded', function() {
    SwPromoCodeInit();
  }, false);
}

function SwPromoCodeInit() {
  const e = new SwPromoCodeEmbed();
}
